(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService','$http','$translate','tmhDynamicLocale','$location'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService,$http,$translate,tmhDynamicLocale,$location) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        var langKey = $location.search().language;
        if(langKey){
            $translate.use(langKey);
            tmhDynamicLocale.set(langKey);
        }

        $timeout(function (){angular.element('#password').focus();});

        $http.get('api/account/email-by-reset-key/'+$stateParams.key).success(function(data){
            vm.emailAccount = data.email;
        });

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
